(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8204],{

/***/ 25541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/design-service",
      function () {
        return __webpack_require__(74102);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PortfolioListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 견적 검증
var PortfolioListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PORTFOLIO */ .Z.PORTFOLIO).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PortfolioListSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 74102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ design_service; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./components/layout/Layout.js + 36 modules
var Layout = __webpack_require__(49807);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/customizing/designService/designInquiryModal.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 10vh;\n    left: 25vw;\n    width: 50vw;\n    height: 80vh;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    @media screen and (max-width: 991px) {\n      top: 10vh;\n      left: 15vw;\n      width: 70vw;\n      height: 80vh;\n    }\n    @media screen and (max-width: 767px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n  .title {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n    & h4 {\n      color: #3bb77e;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: 0px 36px 36px 36px !important;\n    & > span {\n      color: black;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n    & h6 {\n      margin-bottom: 10px;\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    @media screen and (max-width: 575px) {\n      .row {\n        display: flex;\n        flex-direction: column;\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n\n  .checkboxWrapper {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n    @media screen and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  .designCheck {\n    margin-bottom: 30px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: ",
        ";\n  word-break: keep-all;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  font-size: 1rem;\n  padding: ",
        ";\n  overflow: hidden;\n  border: 2px solid #ececec;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  color: #4e4e4e;\n  border-color: ",
        ";\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n\n  & img {\n    margin: 0 auto;\n  }\n\n  .label_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #4e4e4e;\n    font-size: 14px;\n    text-align: center;\n\n    & i {\n      padding-top: 1px;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 20px;\n  row-gap: 10px;\n  & input {\n    padding: 6px 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7a54741-0"
})(_templateObject());
var CheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7a54741-1"
})(_templateObject1(), function(props) {
    return props.design ? "5px" : "0";
});
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-f7a54741-2"
})(_templateObject2(), function(props) {
    return props.design ? "fit-content" : "100%";
}, function(props) {
    return props.design ? "10px 20px" : "10px 10px";
}, function(props) {
    return props.checked ? "#d6f2e5" : "#fff";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var FileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7a54741-3"
})(_templateObject3());
var DesignInquiryModal = function(param) {
    var onClickInquiry = param.onClickInquiry, submitInquiry = param.submitInquiry, openInquiryModal = param.openInquiryModal, onChangeInquiry = param.onChangeInquiry, inquiryInputs = param.inquiryInputs;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiry();
    };
    var planArr = [
        {
            value: "\uBCA0\uC774\uC9C1 A"
        },
        {
            value: "\uBCA0\uC774\uC9C1 B"
        },
        {
            value: "\uC2A4\uD0E0\uB2E4\uB4DC"
        },
        {
            value: "\uBE0C\uB79C\uB4DC"
        },
        {
            value: "\uC0C1\uB2F4 \uD6C4 \uACB0\uC815"
        }, 
    ];
    var designArr = [
        {
            value: "\uC774\uBBF8 \uC0AC\uC6A9\uC911\uC778 \uD328\uD0A4\uC9C0 \uB514\uC790\uC778 Ai \uD30C\uC77C\uC774 \uC788\uC73C\uB098 \uC218\uC815\uC774 \uD544\uC694\uD574\uC694"
        },
        {
            value: "\uB514\uC790\uC778\uC744 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC544\uC694"
        },
        {
            value: "\uD328\uD0A4\uC9C0 \uB514\uC790\uC778\uC740 \uC5C6\uACE0 \uB85C\uACE0 Ai \uD30C\uC77C\uB9CC \uAC00\uC9C0\uACE0 \uC788\uC5B4\uC694."
        },
        {
            value: "\uB514\uC790\uC778 \uC0AC\uC9C4\uC740 \uC788\uC73C\uB098 Ai \uD30C\uC77C\uC740 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC544\uC694"
        },
        {
            value: "\uAE30\uC874 \uC0AC\uC6A9\uD588\uB358 \uB514\uC790\uC778 Ai \uD30C\uC77C\uC740 \uC788\uC73C\uB098 \uC0C8\uB85C \uB9CC\uB4E4\uACE0 \uC2F6\uC5B4\uC694."
        },
        {
            value: "\uAE30\uD0C0 (\uC758\uACAC\uC740 \uBB38\uC758\uC0AC\uD56D\uC5D0 \uB0A8\uACA8\uC8FC\uC138\uC694)"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: onClickInquiry
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790 \uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("name")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790 \uC5F0\uB77D\uCC98"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("tel")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC5C5\uCCB4\uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("company")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC218\uB7C9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("cnt")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uD3EC\uC7A5\uC0C1\uD488 \uC815\uBCF4"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    onChange: onChangeInquiry("usages"),
                                                    placeholder: "ex) \uB18D\uC0B0\uBB3C \uB2EC\uAE30, \uC758\uB958 \uB4F1"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC6D0\uD558\uB294 \uC0C1\uD488"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    onChange: onChangeInquiry("option_1"),
                                                    placeholder: "ex) \uB178\uD14C\uC774\uD504 \uBC15\uC2A4, \uACE8\uD310\uC9C0 \uBC15\uC2A4, \uBC14\uC774\uC624 \uBE44\uB2D0\uBD09\uD22C"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC6D0\uD558\uB294 \uD50C\uB79C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "checkboxWrapper",
                                                    children: planArr.map(function(el, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBox, {
                                                            className: "custome-checkbox",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: "".concat(el.value),
                                                                    name: "planOptions",
                                                                    className: "form-check-input",
                                                                    value: "".concat(el.value),
                                                                    onChange: onChangeInquiry("option_2")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxLabel, {
                                                                    htmlFor: "".concat(el.value),
                                                                    value: "".concat(el.value),
                                                                    checked: inquiryInputs["option_2"] === el.value,
                                                                    style: {
                                                                        textTransform: "capitalize"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "label_title",
                                                                        children: el.value
                                                                    })
                                                                })
                                                            ]
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uAC00\uC9C0\uACE0 \uACC4\uC2E0 \uB514\uC790\uC778\uC774 \uC788\uC73C\uC2E0\uAC00\uC694?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "designCheck",
                                                    children: designArr.map(function(el, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBox, {
                                                            className: "custome-checkbox",
                                                            design: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: "".concat(el.value),
                                                                    name: "designOptions",
                                                                    className: "form-check-input",
                                                                    value: "".concat(el.value),
                                                                    onChange: onChangeInquiry("option_3")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxLabel, {
                                                                    htmlFor: "".concat(el.value),
                                                                    value: "".concat(el.value),
                                                                    checked: inquiryInputs["option_3"] === el.value,
                                                                    style: {
                                                                        textTransform: "capitalize"
                                                                    },
                                                                    design: true,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "label_title",
                                                                        children: el.value
                                                                    })
                                                                })
                                                            ]
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uBB38\uC758 \uB0B4\uC6A9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    type: "text",
                                                    onChange: onChangeInquiry("content"),
                                                    placeholder: "ex) \uC5B8\uC81C\uAE4C\uC9C0 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uC5B4\uB5A4 \uB514\uC790\uC778\uC11C\uBE44\uC2A4\uAC00 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uCD94\uAC00\uC801\uC778 \uBB38\uC758\uC0AC\uD56D\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uCCA8\uBD80 \uD30C\uC77C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file3")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: submitInquiry,
                                    children: "\uBB38\uC758\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var designInquiryModal = (DesignInquiryModal);

// EXTERNAL MODULE: ./api/portfolio.js
var portfolio = __webpack_require__(80337);
;// CONCATENATED MODULE: ./components/customizing/designService/designReferenceModal.js
function designReferenceModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function designReferenceModal_templateObject() {
    var data = designReferenceModal_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  .title {\n    font-size: 2rem;\n    margin-bottom: 30px;\n    font-weight: 700;\n    color: #3bb77e;\n    text-align: center;\n  }\n\n  .desc {\n    min-height: 80px;\n    color: #5d5d5d;\n    line-height: 1.5;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 1.3rem;\n    margin-bottom: 20px;\n    text-align: center;\n    word-break: keep-all;\n    & strong {\n      font-weight: 300;\n      color: black;\n      background-color: #47e99f;\n    }\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 5vh;\n    left: 25vw;\n    width: 50vw;\n    height: 90vh;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    @media screen and (max-width: 991px) {\n      top: 5vh;\n      left: 5vw;\n      width: 90vw;\n      height: 90vh;\n    }\n    @media screen and (max-width: 575px) {\n      left: 0vw;\n      width: 100vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: 0px 36px 36px 36px !important;\n    & > span {\n      color: black;\n    }\n  }\n\n  .ref_desc {\n    font-size: 1rem;\n    line-height: 1.2;\n    color: #5a5a5a;\n    margin-bottom: 20px;\n    & strong {\n      color: #202020;\n      font-weight: 500;\n    }\n    .info {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      background-color: #f3f3f3;\n      border-radius: 10px;\n      padding: 20px;\n      & span {\n        display: flex;\n        align-items: start;\n        margin-bottom: 10px;\n        word-break: keep-all;\n        & img {\n          margin-right: 10px;\n        }\n      }\n    }\n    .range {\n      background-color: #d4e9df;\n      border-radius: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 10px;\n      & h6 {\n        margin-right: 10px;\n        color: #097e48;\n      }\n      & span {\n        margin-bottom: 0;\n      }\n    }\n  }\n  .ref_title {\n    margin: 30px auto 20px;\n  }\n"
    ]);
    designReferenceModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function designReferenceModal_templateObject1() {
    var data = designReferenceModal_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 15px;\n\n  @media screen and (max-width: 575px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    designReferenceModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function designReferenceModal_templateObject2() {
    var data = designReferenceModal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  overflow: hidden;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n  :hover {\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n  }\n"
    ]);
    designReferenceModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function designReferenceModal_templateObject3() {
    var data = designReferenceModal_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    designReferenceModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = designReferenceModal_taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var designReferenceModal_ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61b4d2dc-0"
})(designReferenceModal_templateObject());
var ReferenceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61b4d2dc-1"
})(designReferenceModal_templateObject1());
var SingleContentBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61b4d2dc-2"
})(designReferenceModal_templateObject2());
var SingleContentImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61b4d2dc-3"
})(designReferenceModal_templateObject3());
var SingleContentImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-61b4d2dc-4"
})(_templateObject4());
var DesginReferenceModal = function(param) {
    var handleReference = param.handleReference, activeType = param.activeType;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return handleReference(activeType);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(designReferenceModal_ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: function() {
                                return handleReference(activeType);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "title_desc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "title",
                                        children: activeType.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "desc_image_price_p",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "desc",
                                            children: activeType.desc
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ref_desc",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "info",
                                    children: [
                                        activeType.referenceInfo.map(function(info, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/page/design/check_on.png",
                                                        alt: "checkOn"
                                                    }),
                                                    info
                                                ]
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "range",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC791\uC5C5\uBC94\uC704"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: activeType.referenceRange
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                className: "ref_title",
                                children: [
                                    activeType.title,
                                    " \uB514\uC790\uC778\uC11C\uBE44\uC2A4 \uB798\uD37C\uB7F0\uC2A4"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceWrapper, {
                                children: activeType.reference && activeType.reference.length > 0 && activeType.reference.map(function(url, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleContentBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleContentImgWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleContentImg, {
                                                src: url,
                                                alt: url
                                            })
                                        })
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var designReferenceModal = (DesginReferenceModal);

;// CONCATENATED MODULE: ./components/customizing/designService/DesignService-styles.js
function DesignService_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DesignService_styles_templateObject() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  margin-top: 50px;\n  padding-bottom: 100px;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    DesignService_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DesignService_styles_templateObject1() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 120%;\n  height: 800px;\n  background-color: #3bb77e;\n  bottom: 0;\n  border-radius: 100% 100% 0 0;\n  z-index: -2;\n"
    ]);
    DesignService_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DesignService_styles_templateObject2() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 30px;\n"
    ]);
    DesignService_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DesignService_styles_templateObject3() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  border-top: 5px solid #3bb77e;\n  width: 70px;\n  margin-top: 15px;\n"
    ]);
    DesignService_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DesignService_styles_templateObject4() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 50px;\n"
    ]);
    DesignService_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 15px;\n  grid-row-gap: 30px;\n  @media screen and (max-width: 991px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = DesignService_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 950px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f9f9f9;\n  border-radius: 20px;\n  padding: 30px 20px;\n  -webkit-box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.2);\n  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.1);\n\n  .m_under_bar {\n    display: none;\n  }\n\n  :last-of-type {\n    margin-right: 0px;\n  }\n\n  .title {\n    font-size: 28px;\n    line-height: 32px;\n    margin-bottom: 30px;\n    font-weight: 700;\n    color: #3bb77e;\n    text-align: center;\n  }\n\n  .desc {\n    min-height: 80px;\n    color: #5d5d5d;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 17px;\n    line-height: 24px;\n    margin-bottom: 50px;\n    text-align: center;\n    word-break: keep-all;\n    & strong {\n      font-weight: 300;\n      color: black;\n      background-color: #47e99f;\n    }\n    & span {\n      :first-of-type {\n        margin-bottom: 20px;\n        color: #323232;\n        font-weight: 600;\n      }\n    }\n  }\n  .image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 50px;\n    max-width: 220px;\n    height: 190px;\n    & img {\n      max-height: 190px;\n    }\n  }\n  .price {\n    margin-bottom: 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 50px;\n    & span {\n      display: flex;\n      align-items: baseline;\n      font-size: 24px;\n      > h3 {\n        font-size: 45px;\n      }\n    }\n  }\n  .check {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 auto;\n    word-break: keep-all;\n    font-size: 20px;\n    margin-bottom: 30px;\n    & li {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      margin-bottom: 20px;\n      & span {\n        display: flex;\n        align-items: center;\n        margin-right: 10px;\n        white-space: nowrap;\n        :first-of-type {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          justify-content: flex-end;\n        }\n        :last-of-type {\n          width: 70%;\n        }\n      }\n      .active {\n        color: #373737 !important;\n        font-weight: 600;\n      }\n      & img {\n        max-width: 24px;\n        max-height: 24px;\n      }\n    }\n  }\n  .comment {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 18px;\n    line-height: 24px;\n    color: #3bb77e;\n    border-top: 1px solid #5d5d5d;\n    padding: 10px;\n    margin-bottom: 30px;\n  }\n  .confirm {\n    width: 100%;\n    text-align: center;\n    display: flex;\n\n    & span {\n      cursor: pointer;\n      margin-right: 5px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n\n      .on {\n        display: none;\n      }\n\n      .off {\n        display: block;\n      }\n\n      .tip {\n        display: none;\n        text-align: center;\n        position: absolute;\n        background-color: #f9f9f9;\n        border: 1px solid #bcbcbc;\n        border-radius: 5px;\n        box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);\n        width: 200%;\n        white-space: nowrap;\n        padding: 2px 5px;\n        top: -80%;\n        left: -50%;\n        margin: 0;\n      }\n\n      :hover {\n        .tip {\n          display: block;\n        }\n        .on {\n          display: block;\n        }\n        .off {\n          display: none;\n        }\n      }\n    }\n\n    & button {\n      width: 80%;\n      font-size: 23px;\n      padding: 5px 10px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .image_price_check {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .desc_image_m {\n    display: none;\n  }\n  .md_m {\n    display: none;\n  }\n  .price_m {\n    display: none;\n  }\n\n  @media screen and (max-width: 1199px) {\n    .title {\n      font-size: 24px;\n    }\n    .desc {\n      font-size: 14px;\n    }\n    .price {\n      & span {\n        font-size: 20px;\n        h3 {\n          font-size: 40px;\n        }\n      }\n      p {\n        font-size: 14px;\n      }\n    }\n    .check {\n      & span {\n        font-size: 18px;\n      }\n      & img {\n        max-width: 22px;\n        max-height: 22px;\n      }\n    }\n    .comment {\n      font-size: 18px;\n    }\n    .confirm {\n      & button {\n        font-size: 20px;\n      }\n    }\n  }\n  @media screen and (max-width: 991px) {\n    height: fit-content;\n    min-height: auto;\n    padding: 30px 10px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    .title_desc {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .title {\n      font-size: 24px;\n    }\n    .desc {\n      font-size: 14px;\n      margin-bottom: 10px;\n      min-height: auto;\n    }\n\n    .image_price_check {\n      flex-direction: row;\n      align-items: center;\n      > div {\n        margin-right: 20px;\n      }\n    }\n\n    .image {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      & img {\n        max-width: 150px;\n      }\n    }\n\n    .price {\n      margin-bottom: 10px;\n      & span {\n        font-size: 18px;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        h3 {\n          font-size: 36px;\n        }\n      }\n      p {\n        font-size: 12px;\n      }\n    }\n    .check {\n      margin-bottom: 10px;\n      & span {\n        font-size: 16px;\n      }\n      & img {\n        max-width: 20px;\n        max-height: 20px;\n      }\n    }\n    .comment {\n      font-size: 16px;\n      line-height: 1.2;\n      text-align: center;\n      word-break: keep-all;\n    }\n    .confirm {\n      & button {\n        font-size: 18px;\n      }\n    }\n  }\n  @media screen and (max-width: 575px) {\n    padding: 20px 10px;\n    display: flex;\n    flex-direction: column;\n\n    .title_desc {\n      display: flex;\n    }\n    .desc_image_price_p {\n      display: none;\n    }\n    .desc_image_m {\n      display: flex;\n      flex-direction: column;\n\n      .desc {\n        margin-bottom: 30px;\n        font-size: 12px;\n        max-width: 170px;\n      }\n    }\n    .md_m {\n      display: flex;\n      width: 100%;\n      justify-content: center;\n      .check_comment_m {\n        .check {\n          margin: 0 0 0 10px;\n          & li {\n            margin-bottom: 13px;\n            & span {\n              & img {\n                min-width: 16px;\n                max-height: 16px;\n              }\n              font-size: 12px;\n            }\n            .active {\n              color: #373737 !important;\n            }\n          }\n        }\n        .comment {\n          border: none;\n          font-size: 12px;\n        }\n      }\n    }\n    .image_price_check {\n      display: none;\n    }\n\n    .m_under_bar {\n      display: block;\n      border-top: 1px solid #5d5d5d;\n      width: 90%;\n    }\n\n    .price_m {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      .price {\n        margin-top: 10px;\n        & span {\n          font-size: 12px;\n        }\n        & h3 {\n          font-size: 26px;\n        }\n        & p {\n          font-size: 12px;\n        }\n      }\n      .confirm {\n        padding: 0;\n      }\n      & button {\n        font-size: 14px;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-52c413b3-0"
})(DesignService_styles_templateObject());
var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-1"
})(DesignService_styles_templateObject1());
// 공통
var CommonTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-2"
})(DesignService_styles_templateObject2());
var CommonUnderBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-3"
})(DesignService_styles_templateObject3());
var HeadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-4"
})(DesignService_styles_templateObject4());
// body
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-5"
})(_templateObject5());
var PriceBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52c413b3-6"
})(_templateObject6());

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./common/modalOverflowHook.js
var modalOverflowHook = __webpack_require__(39277);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./components/customizing/designService/DesignService.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var designArr = [
    {
        title: "\uBCA0\uC774\uC9C1 A",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uAC04\uB2E8\uD55C \uAD50\uC815 \uB610\uB294 \uC7AC\uBC30\uCE58 \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "\uB85C\uACE0\uC640 \uD328\uD0A4\uC9C0\uB514\uC790\uC778\uC774 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ai\uD30C\uC77C\uB85C \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                            ]
                        }),
                        ")"
                    ]
                })
            ]
        }),
        m_desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uAC04\uB2E8\uD55C \uAD50\uC815 \uB610\uB294 \uC7AC\uBC30\uCE58 \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "\uB85C\uACE0\uC640 \uD328\uD0A4\uC9C0\uB514\uC790\uC778\uC774",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ai\uD30C\uC77C\uB85C \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                            ]
                        }),
                        ")"
                    ]
                })
            ]
        }),
        img: "/assets/imgs/page/design/basicA.png",
        price: "30,000",
        checkArr: [
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB514\uC790\uC778 \uAD50\uC815"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uAC04\uB2E8\uD55C \uBC30\uCE58"
            },
            {
                img: "/assets/imgs/page/design/check_off.png",
                content: "\uB85C\uACE0(\uC77C\uB7EC\uC2A4\uD2B8)"
            },
            {
                img: "/assets/imgs/page/design/check_off.png",
                content: "\uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
            }, 
        ],
        code: "P1111",
        referenceInfo: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "ai \uD328\uD0A4\uC9C0 \uB514\uC790\uC778 \uD30C\uC77C"
                    }),
                    "\uBCF4\uC720 \uC2DC,",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uAD50\uC815 \uBC0F \uBC30\uCE58"
                    }),
                    "\uB9CC \uD544\uC694\uD558\uB2E4\uBA74 \uBCA0\uC774\uC9C1 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uCD94\uCC9C\uD569\uB2C8\uB2E4."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\uBD09\uD22C\uD3EC\uC7A5\uC7AC\uC758"
                    }),
                    " \uC778\uC1C4 \uC11C\uBE44\uC2A4\uC785\uB2C8\uB2E4."
                ]
            }), 
        ],
        referenceRange: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\uB514\uC790\uC778 \uC77C\uBD80 \uAD50\uC815 "
                }),
                "\uB610\uB294 \uC0C8\uB85C\uC6B4 \uD328\uD0A4\uC9C0\uC5D0 \uB9DE\uCD98",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\uB514\uC790\uC778\uC774\uB098 \uD14D\uC2A4\uD2B8 \uC7AC\uBC30\uCE58"
                })
            ]
        }),
        reference: [
            "https://file.caretbio.com/caretbio/fa53c0204daf0a879bb08ae0882cf610.png", 
        ],
        comment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uB514\uC790\uC778 \uC2DC\uC548 1\uAC1C, \uC218\uC815 2\uBC88"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "(\uD55C \uAC74\uB2F9 1~5\uC77C \uC18C\uC694)"
                })
            ]
        })
    },
    {
        title: "\uBCA0\uC774\uC9C1 B",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uAC04\uB2E8\uD55C \uAD50\uC815 \uB610\uB294 \uC7AC\uBC30\uCE58 \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "\uB85C\uACE0\uC640 \uD328\uD0A4\uC9C0\uB514\uC790\uC778\uC774 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ai\uD30C\uC77C\uB85C \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                            ]
                        }),
                        ")"
                    ]
                })
            ]
        }),
        m_desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uAC04\uB2E8\uD55C \uAD50\uC815 \uB610\uB294 \uC7AC\uBC30\uCE58 \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "\uB85C\uACE0\uC640 \uD328\uD0A4\uC9C0\uB514\uC790\uC778\uC774",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " ai\uD30C\uC77C\uB85C \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                            ]
                        }),
                        ")"
                    ]
                })
            ]
        }),
        img: "/assets/imgs/page/design/basicB.png",
        price: "50,000",
        checkArr: [
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB514\uC790\uC778 \uAD50\uC815"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uAC04\uB2E8\uD55C \uBC30\uCE58"
            },
            {
                img: "/assets/imgs/page/design/check_off.png",
                content: "\uB85C\uACE0(\uC77C\uB7EC\uC2A4\uD2B8)"
            },
            {
                img: "/assets/imgs/page/design/check_off.png",
                content: "\uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
            }, 
        ],
        code: "P1111",
        referenceInfo: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "ai \uD328\uD0A4\uC9C0 \uB514\uC790\uC778 \uD30C\uC77C"
                    }),
                    "\uBCF4\uC720 \uC2DC,",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uAD50\uC815 \uBC0F \uBC30\uCE58"
                    }),
                    "\uB9CC \uD544\uC694\uD558\uB2E4\uBA74 \uBCA0\uC774\uC9C1 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uCD94\uCC9C\uD569\uB2C8\uB2E4."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FSC\uB85C\uACE0"
                    }),
                    "\uC640 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uB9C8\uD06C "
                    }),
                    "\uBAA8\uB450",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\uC778\uC1C4 \uAC00\uB2A5"
                    }),
                    "\uD569\uB2C8\uB2E4."
                ]
            }), 
        ],
        referenceRange: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\uB514\uC790\uC778 \uC77C\uBD80 \uAD50\uC815 "
                }),
                "\uB610\uB294 \uC0C8\uB85C\uC6B4 \uD328\uD0A4\uC9C0\uC5D0 \uB9DE\uCD98",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\uB514\uC790\uC778\uC774\uB098 \uD14D\uC2A4\uD2B8 \uC7AC\uBC30\uCE58"
                })
            ]
        }),
        reference: [
            "https://file.caretbio.com/caretbio/b0bed1423a9bcee44c9035b74a7fa445.jpeg", 
        ],
        comment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uB514\uC790\uC778 \uC2DC\uC548 1\uAC1C, \uC218\uC815 2\uBC88"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "(\uD55C \uAC74\uB2F9 1~5\uC77C \uC18C\uC694)"
                })
            ]
        })
    },
    {
        title: "\uC2A4\uD0E0\uB2E4\uB4DC",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uBE0C\uB79C\uB4DC \uC774\uBBF8\uC9C0\uC5D0 \uB9DE\uB294 \uB514\uC790\uC778 \uC5C5\uADF8\uB808\uC774\uB4DC"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "\uB85C\uACE0ai\uD30C\uC77C\uC744 \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                        }),
                        ")"
                    ]
                })
            ]
        }),
        m_desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uBE0C\uB79C\uB4DC \uC774\uBBF8\uC9C0\uC5D0 \uB9DE\uB294 \uB514\uC790\uC778 \uC5C5\uADF8\uB808\uC774\uB4DC"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "\uB85C\uACE0ai\uD30C\uC77C\uC744 \uBCF4\uC720\uD55C \uC0C1\uD0DC"
                        }),
                        ")"
                    ]
                })
            ]
        }),
        img: "/assets/imgs/page/design/standard.png",
        price: "300,000",
        checkArr: [
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB514\uC790\uC778 \uAD50\uC815 & \uBC30\uCE58"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uD328\uD0A4\uC9C0\uB514\uC790\uC778"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB85C\uACE0(\uC77C\uB7EC\uC2A4\uD2B8)"
            },
            {
                img: "/assets/imgs/page/design/check_off.png",
                content: "\uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
            }, 
        ],
        code: "P1112",
        referenceInfo: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "\uAE30\uBCF8 \uC18C\uC720\uD558\uB358 \uD328\uD0A4\uC9C0 \uB514\uC790\uC778\uC774 \uC544\uB2CC",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            " ",
                            "\uBE0C\uB79C\uB4DC\uC758 \uC774\uBBF8\uC9C0\uB098 \uCEE8\uC149\uC744 \uD65C\uC6A9\uD558\uC5EC \uC0C8\uB86D\uAC8C \uB514\uC790\uC778\uC744 \uC6D0\uD558\uB294 \uBD84\uB4E4\uAED8",
                            " "
                        ]
                    }),
                    "\uC2A4\uD0E0\uB2E4\uB4DC \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uCD94\uCC9C\uD569\uB2C8\uB2E4."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FSC\uB85C\uACE0"
                    }),
                    "\uC640 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uB9C8\uD06C "
                    }),
                    "\uBAA8\uB450",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\uC778\uC1C4 \uAC00\uB2A5"
                    }),
                    "\uD569\uB2C8\uB2E4."
                ]
            }), 
        ],
        referenceRange: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\uBE0C\uB79C\uB4DC \uC774\uBBF8\uC9C0"
                }),
                "\uC5D0 \uB9DE\uCDB0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: " \uC6D0\uD558\uB294 \uC0C9\uC0C1\uC73C\uB85C \uD328\uD0A4\uC9C0 \uB514\uC790\uC778 "
                }),
                "\uC5C5\uADF8\uB808\uC774\uB4DC"
            ]
        }),
        reference: [
            "https://file.caretbio.com/caretbio/d8017bdf784b6829ca9f0e3aab79bfa3.jpeg", 
        ],
        comment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uB514\uC790\uC778 \uC2DC\uC548 2\uAC1C, \uC218\uC815 2\uBC88"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "(\uD55C \uAC74\uB2F9 3~9\uC77C \uC18C\uC694)"
                })
            ]
        })
    },
    {
        title: "\uBE0C\uB79C\uB4DC",
        desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uC804\uCCB4\uC801\uC778 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "\uC804\uBC18\uC801\uC778 \uB514\uC790\uC778 \uB9AC\uB274\uC5BC\uC774 \uD544\uC694\uD55C \uC0C1\uD0DC"
                        }),
                        ")"
                    ]
                })
            ]
        }),
        m_desc: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uC804\uCCB4\uC801\uC778 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "\uC804\uBC18\uC801\uC778 \uB514\uC790\uC778 \uB9AC\uB274\uC5BC\uC774 \uD544\uC694\uD55C \uC0C1\uD0DC"
                        }),
                        ")"
                    ]
                })
            ]
        }),
        img: "/assets/imgs/page/design/brand.png",
        price: "500,000",
        checkArr: [
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB514\uC790\uC778 \uAD50\uC815 & \uBC30\uCE58"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uD328\uD0A4\uC9C0\uB514\uC790\uC778"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uB85C\uACE0(\uC77C\uB7EC\uC2A4\uD2B8)"
            },
            {
                img: "/assets/imgs/page/design/check_on.png",
                content: "\uBE0C\uB79C\uB4DC \uB514\uC790\uC778"
            }, 
        ],
        code: "P1113",
        referenceInfo: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "\uBE0C\uB79C\uB4DC \uC0C8\uB0B4\uAE30 \uB610\uB294",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uBE0C\uB79C\uB4DC \uB514\uC790\uC778\uC758 \uC804\uBC18\uC801\uC778 \uB9AC\uB274\uC5BC\uC774 \uD544\uC694\uD55C \uACBD\uC6B0 "
                    }),
                    "\uBE0C\uB79C\uB4DC \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uCD94\uCC9C\uD569\uB2C8\uB2E4."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FSC\uB85C\uACE0"
                    }),
                    "\uC640 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: " \uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uB9C8\uD06C "
                    }),
                    "\uBAA8\uB450",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\uC778\uC1C4 \uAC00\uB2A5"
                    }),
                    "\uD569\uB2C8\uB2E4."
                ]
            }), 
        ],
        referenceRange: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "\uB85C\uACE0, \uD328\uD0A4\uC9C0 \uB4F1 \uAD00\uB828",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: " \uB514\uC790\uC778 \uC804\uBC18"
                })
            ]
        }),
        reference: [
            "https://file.caretbio.com/caretbio/9382cbb95fe82274922756744c5a3620.jpeg", 
        ],
        comment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "\uB514\uC790\uC778 \uC2DC\uC548 2\uAC1C, \uC218\uC815 2\uBC88"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "(\uC138\uBD80\uC0AC\uD56D \uBCC4\uB3C4 \uBB38\uC758)"
                })
            ]
        })
    }, 
];
var DesignService = function(param) {
    var _$isLoaded = param.isLoaded, _$isLoading = param.isLoading;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), openInquiryModal = ref[0], setOpenInquiryModal = ref[1];
    var ref1 = (0,react.useState)({}), inquiryInputs = ref1[0], setInquiryInputs = ref1[1];
    // 문의 완료
    var ref2 = (0,react.useState)(false), openInquiryComplete = ref2[0], setOpenInquiryComplete = ref2[1];
    var ref3 = (0,react.useState)(false), openReference = ref3[0], setOpenReference = ref3[1];
    var ref4 = (0,react.useState)(""), activeType = ref4[0], setActiveType = ref4[1];
    // 제작 문의
    var onClickInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(0,auth/* getCookie */.ej)("token")) {
                            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
                            setTimeout(function() {
                                router.push("/login");
                            }, 500);
                        } else {
                            setOpenInquiryModal(function(prev) {
                                return !prev;
                            });
                            setInquiryInputs({});
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(id) {
        return function(e) {
            if (id.includes("file")) {
                setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.files[0])));
                return;
            }
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.value)));
        };
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    // 제작 문의 등록
    var submitInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || inquiryInputs.name === "" || !inquiryInputs.tel || inquiryInputs.tel === "" || !inquiryInputs.company || inquiryInputs.company === "" || !inquiryInputs.cnt || inquiryInputs.cnt === "" || !inquiryInputs.usages || inquiryInputs.usages === "" || !inquiryInputs.option_1 || inquiryInputs.option_1 === "" || !inquiryInputs.option_2 || inquiryInputs.option_2 === "" || !inquiryInputs.option_3 || inquiryInputs.option_3 === "" || !inquiryInputs.content || inquiryInputs.content === "")) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        _$isLoading();
                        body = _objectSpread({
                            modes: "InquirySet",
                            division: "D",
                            pcode: "P000000"
                        }, inquiryInputs);
                        _ctx.next = 10;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 10:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            _$isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            _$isLoaded();
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    // 레퍼런스
    var handleReference = function(el) {
        setActiveType(el);
        setOpenReference(function(prev) {
            return !prev;
        });
    };
    var modalScrollHook = (0,modalOverflowHook/* default */.Z)(openInquiryModal || openInquiryComplete || openReference);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uB9DE\uCDA4\uC81C\uC791",
                subTitle: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4",
                pageTitle: SeoMeta/* SeoMeta.designService.title */.e.designService.title,
                pageDesc: SeoMeta/* SeoMeta.designService.description */.e.designService.description,
                pageKeyword: SeoMeta/* SeoMeta.designService.keywords */.e.designService.keywords,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonUnderBar, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
                            className: "container",
                            children: designArr && designArr.map(function(el, i1) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "title_desc",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    className: "title",
                                                    children: el.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "desc_image_price_p",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "desc",
                                                            children: el.desc
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "image",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: el.img
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    children: el.price
                                                                                }),
                                                                                "\uC6D0"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: "(VAT \uBCC4\uB3C4)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image_price_check",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "check",
                                                        children: el.checkArr.map(function(check, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: check.img,
                                                                            alt: "check"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "".concat(check.img.includes("on") && "active"),
                                                                        children: check.content
                                                                    })
                                                                ]
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "comment",
                                                        children: el.comment
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "confirm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                onClick: function() {
                                                                    return handleReference(el);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "tip box",
                                                                        children: "\uC790\uC138\uD788 \uBCF4\uAE30"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: "on",
                                                                        src: "https://file.caretbio.com/caretbio/182da3a0c1adc2fefa3a62705ef29ae6.png"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        className: "off",
                                                                        src: "https://file.caretbio.com/caretbio/49ed80f02ab51a797d2c02579e73d687.png"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn",
                                                                onClick: onClickInquiry,
                                                                children: "\uBB38\uC758\uD558\uAE30"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md_m",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "desc_image_m",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "desc",
                                                            children: el.m_desc
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "image",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: el.img
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "check_comment_m",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "check",
                                                            children: el.checkArr.map(function(check, i) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: check.img,
                                                                                alt: "check"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "".concat(check.img.includes("on") && "active"),
                                                                            children: check.content
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "comment",
                                                            children: el.comment
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "m_under_bar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "price_m",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "price",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    children: el.price
                                                                }),
                                                                "\uC6D0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "(VAT \uBCC4\uB3C4)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "confirm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            onClick: function() {
                                                                return handleReference(el);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "on",
                                                                    src: "https://file.caretbio.com/caretbio/182da3a0c1adc2fefa3a62705ef29ae6.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "off",
                                                                    src: "https://file.caretbio.com/caretbio/49ed80f02ab51a797d2c02579e73d687.png"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn",
                                                            onClick: onClickInquiry,
                                                            children: "\uBB38\uC758\uD558\uAE30"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, i1);
                            })
                        })
                    ]
                })
            }),
            openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(designInquiryModal, {
                onClickInquiry: onClickInquiry,
                openInquiryModal: openInquiryModal,
                submitInquiry: submitInquiry,
                onChangeInquiry: onChangeInquiry,
                inquiryInputs: inquiryInputs
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            }),
            openReference && /*#__PURE__*/ (0,jsx_runtime.jsx)(designReferenceModal, {
                handleReference: handleReference,
                activeType: activeType
            })
        ]
    });
};
var mapDispatchToProps = {
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var designService_DesignService = ((0,es/* connect */.$j)(null, mapDispatchToProps)(DesignService));

;// CONCATENATED MODULE: ./pages/customizing/design-service/index.js


var DesignServicePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(designService_DesignService, {})
    });
};
/* harmony default export */ var design_service = (DesignServicePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,9807,4027,9774,2888,179], function() { return __webpack_exec__(25541); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);